export var hero = function hero() {
  var el = document.querySelector(".p-home-hero");
  if (!el) return;

  var img = el.querySelector(".p-home-hero__image img");
  var started = false;
  var start = function start() {
    if (started) return;
    started = true;
    el.classList.add("is-inviewActive");
  };

  if (img) {
    // decode() はダウンロード＋デコード完了で resolve。
    // 既にキャッシュ済みでも、未ロードでも同じ書き方でOK。
    img.decode().then(start).catch(start); // 失敗時もアニメは動かす
  } else {
    start();
  }

  setTimeout(start, 3000); // 保険：最大3秒でフォールバック発火
};
